import styles from "@styles/pages/cdp/segmentations.module.scss";

import classNames from "classnames/bind";
import { useState } from "react";

const css = classNames.bind(styles);

export const ModifierTypes = {
  in_all: "Em todas as",
  has_some: "Em uma das",
  has_never: "Nunca",
  has_only: "Somente",
};

export const Modifiers = ({ modifiers, activeModifier, onChangeModifier }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className={styles.modifiers}>
      <div
        className={css({
          selectedCategory: true,
          collapsed: collapsed,
        })}
        onClick={() => setCollapsed(!collapsed)}
      >
        <p>{activeModifier?.name}</p>
        <i className="fas fa-chevron-down" />
      </div>

      <div
        className={css({
          collapsedCategories: true,
          in: collapsed,
          out: !collapsed,
        })}
      >
        <ul className={styles.options}>
          {(modifiers || [])
            .filter((m) => m.id !== activeModifier?.id)
            .map((m) => (
              <li
                key={m.name}
                onClick={() => {
                  onChangeModifier(m);
                  setCollapsed(false);
                }}
              >
                {m.name}
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};
